import { CUSTOMER_APP_ID, organizationIds } from "../config/constants";
import {
  IAddUpdateAccessControlPageState,
  INewAccessControlUserResponseObject,
  IAccessControlUsersNormalized,
  IAllClientRolesResponse,
  IClientsResponseObject,
  IRolesResponseObject,
  ICreateUpdateAccessControlUserNormalizedReq,
} from "../interfaces/Index";

export const normalizeAccessControlUserCreatePayload = (
  req: IAddUpdateAccessControlPageState
): ICreateUpdateAccessControlUserNormalizedReq => {
  return {
    fullName: req.fullName,
    phoneNumber: req.phoneNumber,
    email: req.email,
    password: req.password,
    confirmPassword: req.password,
    nationalId: req.nationalId,
    clientIds: normalizeCreateUpdateClientReq(req.clients),
    roleIds: normalizeCreateUpdateRolesReq(req.roles),
    filters: req.filters,
    organizationId: organizationIds[1].id,
  };
};

export const normalizeAccessControlUserUpdatePayload = (
  req: IAddUpdateAccessControlPageState
): ICreateUpdateAccessControlUserNormalizedReq => {
  const payload: ICreateUpdateAccessControlUserNormalizedReq = {
    id: req.id,
    status: req.status ? "ENABLED" : "DISABLED",
    fullName: req.fullName,
    phoneNumber: req.phoneNumber,
    email: req.email,
    nationalId: req.nationalId,
    clientIds: normalizeCreateUpdateClientReq(req.clients),
    roleIds: normalizeCreateUpdateRolesReq(req.roles),
    filters: req.filters,
    organizationId: req.organizationId[0]
      ? req.organizationId[0].id
      : req.organizationId.id,
  };
  return payload;
};

const normalizeCreateUpdateClientReq = (
  clients: IClientsResponseObject[]
): string[] => {
  return clients.map((client) => {
    return client.id;
  });
};

const normalizeCreateUpdateRolesReq = (
  roles: IRolesResponseObject[]
): string[] => {
  return roles.map((role) => {
    return role.id;
  });
};

export const normalizeFetchAccessControlUserResponse = (
  res: Array<INewAccessControlUserResponseObject>,
  pagination: any,
  isPaginatedRes: boolean
) => {
  let payload: any = {
    pagination: res.length === 50 ? pagination : false,
    isPaginatedRes,
  };
  const accessControlUserPayload: Array<IAccessControlUsersNormalized> =
    res.map((accessControlUser) => {
      return {
        id: accessControlUser.user.id,
        fullName: accessControlUser.user.fullName,
        phoneNumber: accessControlUser.user.phoneNumber,
        email: accessControlUser.user.email,
        cnicNumber: accessControlUser.user.nationalId,
        status: accessControlUser.user.accountStatus,
        countryCode: accessControlUser.user.countryCode,
        roles: normalizeFetchUserRoleArray(
          accessControlUser.roles,
          accessControlUser.clients
        ),
        clients: accessControlUser.clients.slice(),
        filters: accessControlUser.filters,
        organizationId: accessControlUser.user.organizationId,
      };
    });
  payload.accessControlUserData = accessControlUserPayload;
  return payload;
};

const normalizeFetchUserRoleArray = (
  roles: Array<any>,
  clients: Array<any>
) => {
  return roles.map((role) => {
    const clientObj = clients.find((client) => role.clientId === client.id);
    return {
      id: role.id,
      title: `${clientObj ? clientObj.name : "-"} - ${role.title}`,
      clientId: role.clientId,
    };
  });
};

export const normalizedClientsRoles = (res: IAllClientRolesResponse) => {
  return (
    res.clients
      // .filter((item) => item.id !== CUSTOMER_APP_ID) // removed filter as per areeb request. dated 9-12-24
      .map((client: IClientsResponseObject) => {
        const clientName = client.name;
        const clientId = client.id;
        return {
          id: client.id,
          name: client.name,
          roles: normalizeRoles(
            clientId,
            clientName,
            client.roles as IRolesResponseObject[]
          ),
        };
      })
  );
};

export const normalizeRoles = (
  clientId: string,
  clientName: string,
  roles: IRolesResponseObject[]
) => {
  return roles.map((role) => {
    return {
      id: role.id,
      title: `${clientName} - ${role.title}`,
      clientId: clientId,
    };
  });
};
